export default "__VITE_ASSET__DR5n8F2z__"